// Identifiant générique d'un choix de formulaire (revue Loïc, ST304-TA-4918) : chaque ChoiceView
// fournie par le back porte déjà un `value` stable et unique par choix (cryptedId pour les entités
// qui en ont une, sinon l'id Doctrine - même repli que App\Form\Util\SubmittedChoiceValue côté
// back). Les composants de choix (puces, grille, liste de cartes) comparent cette même valeur,
// recalculée ici à partir de la donnée brute d'un choix sélectionné (vars.value, qui garde la
// donnée entière du choix, pas sa seule valeur) plutôt que de redériver chacun sa propre clé
// (cryptedId puis id) - ça échouait silencieusement pour toute entité sans cryptedId (11 entités
// seulement dans le projet).
class ChoiceIdentityManager {
  identity(value) {
    if (value === null || value === undefined) {
      return null;
    }
    if (typeof value === "object") {
      if (value.cryptedId !== undefined) {
        return value.cryptedId;
      }
      return value.id !== undefined ? String(value.id) : null;
    }
    return String(value);
  }
}

export const choiceIdentityManager = new ChoiceIdentityManager();
